import { Route } from '@angular/router'
import { canActivateAuth, canActivateNotAuth } from '@mos/shared/auth'

export const appCommonRoutes: Route[] = [
	{
		// Google's sign-in popup lands here, so this route stays guard-free: under canActivateNotAuth
		// an already-signed-in player fell through to '**' and the popup displayed the game itself
		// before closing.
		path: 'auth/google',
		title: $localize`:@@title.default:Memory of Souls : Visual novel d'amour, de rêves et dons extraordinaires`,
		loadComponent: () => import('@mos/client/web/auth/components/auth/auth.component').then((m) => m.AuthComponent),
	},
	{
		path: '',
		canMatch: [canActivateNotAuth],
		title: $localize`:@@title.default:Memory of Souls : Visual novel d'amour, de rêves et dons extraordinaires`,
		loadChildren: () => import('@mos/client/web/landing/feature/pages/landing.routes').then((m) => m.landingRoutes),
	},
	{
		path: '',
		pathMatch: 'prefix',
		loadComponent: () => import('@mos/client/web/home/pages/home/home.layout').then((m) => m.HomeLayout),
		canMatch: [canActivateAuth],
		title: $localize`:@@title.default:Memory of Souls : Visual novel d'amour, de rêves et dons extraordinaires`,
		children: [
			{
				path: '',
				pathMatch: 'prefix',
				loadChildren: () => import('@mos/client/web/game/feature/pages/game.routes').then((m) => m.gameRoutes),
			},
			{
				path: 'characters',
				pathMatch: 'prefix',
				loadChildren: () =>
					import('@mos/client/web/journal/pages/journal.routes').then((m) => m.charactersRoutes),
			},
			{
				path: 'help',
				pathMatch: 'prefix',
				loadChildren: () => import('@mos/client/web/help/pages/help.routes').then((m) => m.helpRoutes),
			},
			{
				path: 'journal',
				pathMatch: 'prefix',
				loadChildren: () => import('@mos/client/web/journal/pages/journal.routes').then((m) => m.journalRoutes),
			},
			{
				path: 'options',
				pathMatch: 'prefix',
				loadChildren: () => import('@mos/client/web/options/pages/options.routes').then((m) => m.optionsRoutes),
			},
			{
				path: 'legal',
				pathMatch: 'prefix',
				loadChildren: () =>
					import('@mos/client/web/legal/pages/legal.routes').then((m) => m.legalConnectedRoutes),
			},
			{
				path: 'shop',
				pathMatch: 'prefix',
				loadChildren: () => import('@mos/client/web/shop/feature/pages/shop.routes').then((m) => m.shopRoutes),
			},
		],
	},
	{ path: '**', redirectTo: '' },
]
